export const version = '1.3.210';


// WEBPACK FOOTER //
// ./src/app/version.ts